import { render, staticRenderFns } from "./ProductSortSelector.vue?vue&type=template&id=59f4d200&"
import script from "./ProductSortSelector.vue?vue&type=script&lang=ts&"
export * from "./ProductSortSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports